import React, { useEffect, useState } from "react";
import axios from "axios";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/home-ayurveda-section`;

const DEFAULT_FORM = {
  title: "Discover Ayurveda Courses",
  subtitle: "Ayurveda Wellness & Healing Programs",
  description:
    'Ayurveda, the ancient "science of life," offers a holistic path to balance your body, mind, and spirit. At Hatha Yogashram, we integrate Ayurveda deeply into our yoga teacher trainings and therapies — from the three doshas and Dinacharya to Shirodhara and seasonal practices.',
  imageUrl: "",
  bookPath: "/BookingForm",
};

export default function AyurvedaSectionAdmin() {
  const [form, setForm] = useState(DEFAULT_FORM);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(API)
      .then((res) => {
        if (res.data?.data) {
          setForm({
            title: res.data.data.title || DEFAULT_FORM.title,
            subtitle: res.data.data.subtitle || DEFAULT_FORM.subtitle,
            description: res.data.data.description || DEFAULT_FORM.description,
            imageUrl: res.data.data.imageUrl || "",
            bookPath: res.data.data.bookPath || DEFAULT_FORM.bookPath,
          });
        }
      })
      .catch((err) => {
        console.error("Failed to load ayurveda section:", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaved(false);
    setError("");

    try {
      await axios.put(API, form);
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save ayurveda section.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-5 mt-5" style={{ maxWidth: 900 }}>
      <h3 className="mb-1">Ayurveda Section</h3>
      <p className="text-muted small mb-4">
        Edit the homepage Ayurveda heading, details, description, and image. The course cards
        still come from the Ayurveda courses in the course catalog.
      </p>

      {error && <div className="alert alert-danger">{error}</div>}
      {saved && <div className="alert alert-success">Ayurveda section saved successfully.</div>}

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              name="title"
              className="form-control"
              value={form.title}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Details / Subtitle</label>
            <input
              type="text"
              name="subtitle"
              className="form-control"
              value={form.subtitle}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            rows={4}
            value={form.description}
            onChange={handleChange}
          />
        </div>

        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label">Image URL</label>
            <input
              type="file"
              name="imageUrl"
              className="form-control"
              value={form.imageUrl}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Book Path</label>
            <input
              type="text"
              name="bookPath"
              className="form-control"
              value={form.bookPath}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="alert alert-info py-2 small mb-4">
          Manage the three Ayurveda cards from the course catalog by editing the
          `ayurveda-5-days`, `ayurveda-10-days`, and `ayurveda-15-days` courses.
        </div>

        <div className="d-flex justify-content-end">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : "Save Ayurveda Section"}
          </button>
        </div>
      </form>
    </div>
  );
}
